import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

import './input.css';

import classNames from 'classnames';

export default class Input extends PureComponent {
    constructor(props){
        super(props);
        this.state = {
            touched:false
        }
        this.onBlur=this.onBlur.bind(this);
        this.onChange=this.onChange.bind(this);
    }
    componentWillMount(){
        if(this.context.Form){
            this.context.Form.attachToForm(this);
        }
    }
    componentWillUnmount(){
        if(this.context.Form){
            this.context.Form.removeFromForm(this);
        }
    }
    onBlur(){
        this.setState({touched:true});
    }
    hasError(validate){
        //The validate flag lets the parent component force validation
        if(this.props.error) return true;
        if(!this.state.touched && !validate) return false;
        return !this.isValid();
    }
    touch(){
        this.setState({touched:true});
    }
    isValid(){
        if(!this.props.value && this.props.required){
            return false;
        }
        //Some old browsers won't have the valid property
        var isHtmlElementValid = this.input.validity ? this.input.validity.valid : true;
        if(!isHtmlElementValid) return false;
        return this.props.isValid ? this.props.isValid() :  true;
    }
    renderError(){
        if(this.props.nomessages) return null;
        return (
            <div className="cl-input_error cl-input_msg">
                <span>{this.props.errorText}</span>
            </div>
        )
    }
    reset(){
        this.setState({touched:false});
    }
    renderValid(){
        if(this.props.nomessages) return null;
        return (
            <div className="cl-input_valid cl-input_msg">{this.props.validText}</div>
        )
    }
    onChange(evt) {
        if (this.props.onChange) {
            this.props.onChange(this.input.value,evt);
        }
    }
    focus(){
        this.input.focus();
    }
    render(){
        const {
            errorText,
            type,
            validate,
            onChange,
            showValid,
            validText,
            isValid,
            nomessages,
            icon,
            blockStyle,
            marBottom,
            ...others
        } = this.props;
        const error = this.hasError(validate);
        const valid = !error && ((this.state.touched || validate) && showValid);
        const className = classNames({
            "cl-input-field":true,
            "cl-input--error":error,
            "cl-input--valid":valid,
            "cl-input-with-icon":!!icon,
            "block-style":!!blockStyle,
            "mar-bottom":!!marBottom,
        })
        return (
            <div className={className}>
                {this.props.label ? <label className="cl-input-label">{this.props.label}</label> : null}
                {icon ? <img alt={this.props.name} className="cl-input-icon" width="18px" height="18px" src={icon}/>: null}
                {type === 'textarea'
                    ? <textarea ref={(input) => {this.input=input}} onChange={this.onChange} {...others} onBlur={this.onBlur} />
                    : <input ref={(input) => {this.input=input}} type={type} onChange={this.onChange} {...others} onBlur={this.onBlur} />
                }
                {error ? this.renderError()  : ''}
                {valid ? this.renderValid() : ''}
            </div>
        )
    }
}

Input.defaultProps={
    showValid:false,
    nomessages:true
}

Input.contextTypes={
    Form:PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/Input/index.js